import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Xevon crash:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            minHeight: "100vh",
            background: "#000",
            color: "#F5F5F5",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "24px",
            fontFamily: "ui-monospace, monospace",
          }}
          data-testid="fatal-error-screen"
        >
          <div style={{ maxWidth: 640, width: "100%", border: "1px solid rgba(255,255,255,0.15)", borderRadius: 16, padding: 24 }}>
            <p style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>Xevon hit an error</p>
            <p style={{ fontSize: 12, color: "#A3A3A3", marginBottom: 16 }}>
              Screenshot this and send it over — it tells us exactly what's wrong.
            </p>
            <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", fontSize: 12, color: "#D4D4D4" }}>
              {String(this.state.error?.message || this.state.error)}
              {"\n\n"}
              {String(this.state.error?.stack || "").slice(0, 1200)}
            </pre>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
